import { api } from "@/services/api";
import {
  CreateMachineryRequest,
  CreateMachineryShiftRequest,
  UpdateDailyCapacityRequest,
  UpdateMachineryRequest,
  UpdateMachineryShiftRequest,
  UpdateTechnicalCapacityRequest,
} from "@/types/machinery";

export const machineryService = {
  getMachinery: async (
    slug: string,
    params?: { search?: string; status?: string; include_inactive?: boolean },
  ) => {
    return api.get("/machinery", {
      params: {
        slug,
        ...params,
      },
    });
  },

  getMachineryById: async (id: string, slug: string, params?: { include_inactive_shifts?: boolean }) => {
    return api.get(`/machinery/${id}`, {
      params: {
        slug,
        ...params,
      },
    });
  },

  createMachinery: async (payload: CreateMachineryRequest) => {
    return api.post("/machinery", payload);
  },

  updateMachinery: async (id: string, payload: UpdateMachineryRequest) => {
    return api.put(`/machinery/${id}`, payload);
  },

  deleteMachinery: async (id: string, slug: string, company_id: string) => {
    return api.delete(`/machinery/${id}`, {
      data: { slug, company_id },
    });
  },

  updateDailyCapacity: async (id: string, payload: UpdateDailyCapacityRequest) => {
    return api.put(`/machinery/${id}/daily-capacity`, payload);
  },

  updateTechnicalCapacity: async (id: string, payload: UpdateTechnicalCapacityRequest) => {
    return api.put(`/machinery/${id}/technical-capacity`, payload);
  },

  listShifts: async (id: string, slug: string, params?: { include_inactive?: boolean }) => {
    return api.get(`/machinery/${id}/shifts`, {
      params: {
        slug,
        ...params,
      },
    });
  },

  createShift: async (id: string, payload: CreateMachineryShiftRequest) => {
    return api.post(`/machinery/${id}/shifts`, payload);
  },

  updateShift: async (id: string, shiftId: string, payload: UpdateMachineryShiftRequest) => {
    return api.put(`/machinery/${id}/shifts/${shiftId}`, payload);
  },

  deleteShift: async (id: string, shiftId: string, slug: string, company_id: string) => {
    return api.delete(`/machinery/${id}/shifts/${shiftId}`, {
      data: {
        slug,
        company_id,
      },
    });
  },
};
